<template>
  <div>
    <div v-for="(item, index) in range" :key="index" class="AllowTimeAllMargin">
      <el-time-picker
        is-range
        v-model="range[index]"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        placeholder="选择时间范围"
        value-format="HH:mm:ss"
        @change="pickerChange"
      >
      </el-time-picker>
      <el-button
        type="text"
        icon="el-icon-circle-close"
        v-if="index !== 0"
        @click="remove(index)"
      ></el-button>
    </div>

    <div style="margin-top: 10px">
      <el-button
        type="primary"
        icon="el-icon-circle-plus-outline"
        @click="add"
        v-if="range.length < 3"
        >添加</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["value"],
  inject: {
    addedit: {
      default: "",
    },
    elFormItem: {
      default: "",
    },
  },
  watch: {
    "addedit.visible": {
      handler(v) {
        if (v) {
          if (this.value) {
            this.range = JSON.parse(this.value);
          } else {
            this.add();
          }
        } else {
          this.range = [];
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      range: [],
    };
  },
  methods: {
    pickerChange() {
      let list = [];
      (this.range || []).forEach((item) => {
        if (item) {
          list.push(item);
        }
      });

      if (list == 0) {
        this.$emit("input", "");
      } else {
        this.$emit("input", JSON.stringify(list));
      }
      if (this.elFormItem) {
        this.elFormItem.validate();
      }
    },
    add() {
      this.range.push(["00:00:00", "23:59:59"]);
      this.pickerChange();
    },
    remove(index) {
      this.range.splice(index, 1);
      this.pickerChange();
    },
  },
};
</script>

<style>
</style>